import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styles from './styles.scss';
import {
  Block,
  Button,
  ExpanderGroup,
  Heading,
  Paragraph,
  IconPlus
} from 'suomifi-ui-components';
import { FieldArray } from 'formik';
import { Services } from './components';
import { serviceSchema, formTitle } from './schema';

export const Form = (
  { formik, sendAttachment, deleteAttachment },
  { intl }
) => {
  const i18n = id => intl.formatMessage({ id });
  const { locale } = intl;
  const helperRef = React.useRef(null);

  return (
    <div className={styles.container}>
      <Block>
        <Heading variant="h2" className="borderless mb-2">
          <FormattedMessage id={formTitle} />
        </Heading>
        <Paragraph>
          <FormattedMessage id="intermediary.serviceInfo.description" />
        </Paragraph>
      </Block>
      <Block>
        <ExpanderGroup showToggleAllButton={false}>
          <FieldArray
            name="formData.serviceData.services"
            render={helpers => {
              helperRef.current = helpers;
              return (
                <Services
                  formik={formik}
                  remove={helpers.remove}
                  i18n={i18n}
                  locale={locale}
                  sendAttachment={sendAttachment}
                  deleteAttachment={deleteAttachment}
                />
              );
            }}
          />
        </ExpanderGroup>
      </Block>
      <Block>
        <Button
          variant="secondary"
          icon={<IconPlus />}
          onClick={() => helperRef?.current?.push(serviceSchema.cast({}))}
        >
          <FormattedMessage id="intermediary.serviceInfo.addService" />
        </Button>
      </Block>
    </div>
  );
};
Form.propTypes = {
  formik: PropTypes.object,
  sendAttachment: PropTypes.func,
  deleteAttachment: PropTypes.func
};

Form.contextTypes = {
  intl: PropTypes.object.isRequired
};

export default Form;
